// Example API integration in Login.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // React Router v6 hook for navigation
import { TextField, Button, Box, Typography, Container } from '@mui/material';
import styled from '@emotion/styled';
import useAuth from '../../hooks/useAuth';
import logo from '../../assets/LOGO-CSC.png';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../Layout/LanguageSwitcher';

const StyledWallpaper = styled('div')`

  background: url('/assets/Login_bg.png') no-repeat center center;
  background-size: cover;
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const StyledBox = styled(Box)`
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  text-align: center;
  background-color: white;
`;

const LanguageSwitcherContainer = styled(Box)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

const StyledButton = styled(Button)`

`;

const StyledError = styled(Typography)`
  text-align: center;
  margin-top: 10px;
`;

const StyledLogo = styled('img')`
  width: 50%;
`;

function Login() {
  const { t } = useTranslation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // State to handle error messages
  const navigate = useNavigate(); // Hook for redirecting to different routes
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent the default form submit behavior
    try {
	const baseURL = process.env.REACT_APP_API_URL || '';
      const response = await axios.post(`${baseURL}/api/auth/login`, {
        username,
        password,
      });
      if (response.data.success) {
        login(response.data.token, response.data.refreshToken);
        navigate('/locations'); // Redirect to the profile
      }else{
        setError(response.data.message);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(t('login.errorUnexpected'));
    } 
  };

  return (
    <StyledWallpaper>
      <LanguageSwitcherContainer>
        <LanguageSwitcher />
      </LanguageSwitcherContainer>
      <StyledContainer>
        <StyledBox>
        <StyledLogo src={logo} alt="Logo" />
          <form onSubmit={handleLogin}>
            <TextField
              label={t('login.username')}
              variant="outlined"
              fullWidth
              margin="normal"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              label={t('login.password')}
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <StyledButton type="submit" variant="contained" fullWidth>
              {t('login.button')}
            </StyledButton>
            {error && <StyledError variant="body2">{error}</StyledError>}
          </form>
        </StyledBox>
      </StyledContainer>
    </StyledWallpaper>
  );

  // return (
  //   <div>
  //     <h2>Login</h2>
  //     <form onSubmit={handleLogin}>
  //       <label>
  //           Username:
  //           <input
  //               type="text"
  //               value={username}
  //               onChange={(e) => setUsername(e.target.value)}
  //           />
  //       </label>
  //       <label>
  //           Password:
  //           <input
  //               type="password"
  //               value={password}
  //               onChange={(e) => setPassword(e.target.value)}
  //           />
  //       </label>
  //       <button type="submit">Login</button>
  //       {error && <div style={{ color: 'red' }}>{error}</div>} {/* Display error message if any */}
  //     </form>
  //   </div>
  // );
}

export default Login;
